import { useContext } from 'react';
import type { UseCurrentAccessPolicyReturn } from '@hooks/useCurrentAccessPolicy';
import { AccessPolicyContext } from './AccessPolicyContext';

// -----------------------------------------------------------------------------
export const useAccessPolicyContext = (): UseCurrentAccessPolicyReturn => {
  const context = useContext(AccessPolicyContext);
  if (context === undefined) {
    throw new Error(
      'useAccessPolicyContext must be used within an AccessPolicyProvider'
    );
  }

  return context;
};
